<template>
  <div class="wrraper driver-details-admin-page">
    <!-- Start Breadcrumb -->
    <div class="mb-3">
      <Breadcrumb :items="items" />
    </div>
    <!-- End Breadcrumb -->

    <!-- Start Main Loader -->
    <MainLoader key="loader" v-if="loading" />
    <!-- End Main Loader -->

    <div key="main" v-else class="main-store-details">
      <!-- Top Modern Floating Header Bar -->
      <div class="modern-card store-hero-card mb-4" v-if="allData">
        <div
          class="d-flex flex-wrap justify-content-between align-items-center gap-3"
        >
          <!-- Store ID & Status Summary -->
          <div class="d-flex align-items-center flex-wrap gap-3">
            <div class="store-id-badge">
              <i class="far fa-store ml-2 text-primary"></i>
              <span>تفاصيل المتجر: </span>
              <strong class="store-num">#{{ allData.id }}</strong>
            </div>

            <!-- Meals Availability Status Chip -->
            <span
              class="badge badge-pill font-weight-bold px-3 py-1"
              :class="
                allData.is_have_meals
                  ? 'bg-success text-white'
                  : 'bg-secondary text-white'
              "
            >
              {{ allData.is_have_meals ? "لديه وجبات" : "بدون وجبات" }}
            </span>
          </div>

          <!-- Header Control Action Buttons -->
          <div class="d-flex flex-wrap align-items-center gap-2">
            <!-- Edit Store Button -->
            <v-btn
              depressed
              color="#783d73"
              class="custom-hero-btn text-white rounded-pill px-4"
              :to="`/googlePlace/edit/${allData.id}`"
            >
              <i class="far fa-edit ml-2"></i>
              تعديل المتجر
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Main Content 2-Column Grid -->
      <div class="row align-items-start" v-if="allData">
        <!-- Left Sidebar Column (3 Cols) -->
        <div class="col-lg-3 mb-4">
          <div class="modern-card store-sidebar-card p-3">
            <!-- Store Image Avatar Ring -->
            <div class="store_image_container text-center mb-3">
              <div class="avatar-glow-ring">
                <img
                  :src="
                    allData.images && allData.images[0]
                      ? allData.images[0].image
                      : ''
                  "
                  v-if="
                    allData.images &&
                    allData.images[0] &&
                    allData.images[0].image
                  "
                  alt="Store Image"
                />
                <img
                  :src="require('@/assets/images/icons/logo.png')"
                  v-else
                  alt="Fallback Logo"
                />
              </div>
            </div>

            <!-- Store Name -->
            <h5 class="text-center font-weight-bold text-dark mb-3">
              {{ allData.name }}
            </h5>

            <!-- Navigation Vertical Tabs -->
            <ul class="store_taps_container mb-4">
              <li class="store_tap">
                <button
                  @click="active = 'info'"
                  :class="active == 'info' ? 'active' : ''"
                >
                  <i class="far fa-info-circle ml-2"></i>
                  <span>بيانات المتجر</span>
                </button>
              </li>

              <li class="store_tap">
                <button
                  @click="active = 'branches'"
                  :class="
                    active == 'branches' || active == 'addBranch'
                      ? 'active'
                      : ''
                  "
                >
                  <i class="far fa-code-branch ml-2"></i>
                  <span>فروع المتجر</span>
                </button>
              </li>

              <li class="store_tap">
                <button
                  @click="active = 'meals'"
                  :class="active == 'meals' ? 'active' : ''"
                >
                  <i class="far fa-utensils ml-2"></i>
                  <span>الوجبات المتاحة</span>
                </button>
              </li>

              <li class="store_tap">
                <button
                  @click="active = 'worktimes'"
                  :class="active == 'worktimes' ? 'active' : ''"
                >
                  <i class="far fa-clock ml-2"></i>
                  <span>أوقات العمل</span>
                </button>
              </li>

              <li class="store_tap">
                <button
                  @click="active = 'store_images'"
                  :class="active == 'store_images' ? 'active' : ''"
                >
                  <i class="far fa-images ml-2"></i>
                  <span>صور المتجر</span>
                </button>
              </li>
            </ul>

            <!-- Account Control Switches -->
            <div class="switches-box p-3 bg-light rounded-lg">
              <div class="d-flex justify-content-between align-items-center">
                <span class="font-weight-bold text-dark small"
                  >لديه وجبات ؟</span
                >
                <v-switch
                  v-model="allData.is_have_meals"
                  readonly
                  dense
                  hide-details
                  class="mt-0 pt-0"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Right Content Area (9 Cols) -->
        <div class="col-lg-9 py-0">
          <Transition name="routerTransition" mode="out-in">
            <StoreInfo v-if="active == 'info'" :data="allData" />

            <StoreBranches
              v-else-if="active == 'branches'"
              @addBranch="active = 'addBranch'"
              @editBranch="eidtBranch"
              @showBranch="showBranch"
            />

            <Meals
              :mealsData="allMealsData"
              v-else-if="active == 'meals'"
              :place_id="allData.place_category?.id"
            />

            <AddBranch
              :id="allData.id"
              v-else-if="active == 'addBranch'"
              @branchAdded="resetStore"
              :clear="clear_fileds"
            />

            <EditBranch
              v-else-if="active == 'editBranch'"
              :id="branchId"
              @branchAdded="resetStore"
            />

            <ShowBranch
              v-else-if="active == 'showBranch'"
              @branchAdded="active = 'branches'"
              :branch_id="branchId"
            />

            <BranchInfo
              v-else-if="active == 'baranch_info'"
              :id="branchId"
              :data="myData"
            />

            <!-- Store Images Gallery View -->
            <div
              v-else-if="active == 'store_images'"
              class="store_gallery_wrapper p-4 p-md-5 mb-5"
            >
              <div
                class="gallery_header mb-4 d-flex align-items-center justify-content-between"
              >
                <div class="header_title_group d-flex align-items-center gap-3">
                  <div class="header_icon_box">
                    <i class="fal fa-images"></i>
                  </div>
                  <div>
                    <h5 class="m-0 font-weight-bold">
                      معرض صور المتجر والوثائق
                    </h5>
                    <span class="text-muted text_small"
                      >معاينة صور المتجر والوثائق الرسمية</span
                    >
                  </div>
                </div>
              </div>

              <div
                class="row g-4"
                v-if="allData && allData.images && allData.images.length > 0"
              >
                <div
                  class="col-xl-4 col-lg-6 col-md-6 col-12 mb-4"
                  v-for="(image, index) in allData.images"
                  :key="image.id || index"
                >
                  <div class="creative_gallery_card">
                    <div class="card_tag_header">
                      <i class="fal fa-image"></i>
                      <span>صورة المتجر #{{ index + 1 }}</span>
                    </div>
                    <div
                      class="gallery_img_container"
                      @click="
                        openImageModal(
                          image.image,
                          'صورة المتجر #' + (index + 1)
                        )
                      "
                    >
                      <img
                        v-if="image.image"
                        :src="image.image"
                        alt="Store Image"
                        class="gallery_img"
                      />
                      <div class="zoom_hover_overlay" v-if="image.image">
                        <div class="zoom_icon_box">
                          <i class="fal fa-search-plus"></i>
                        </div>
                        <span>انقر لتكبير المعاينة</span>
                      </div>
                      <div class="empty_image_placeholder" v-else>
                        <i class="fal fa-image-slash"></i>
                        <span>لم يتم إرفاق صورة</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="text-center py-5 text-muted">
                <i class="fal fa-images fa-3x mb-3 text-secondary"></i>
                <p class="m-0 font-weight-bold">
                  لا يوجد صور مرفقة لهذا المتجر
                </p>
              </div>
            </div>

            <!-- Working Times View -->
            <div v-else-if="active == 'worktimes'" class="worktimes-container">
              <div class="row">
                <div
                  class="col-lg-4 col-md-6 mb-4"
                  v-for="work_day in allData.working_times"
                  :key="work_day.id"
                >
                  <div
                    class="magic-time-card"
                    :class="{ 'is-disabled': !work_day.enabled }"
                  >
                    <div
                      class="card-header d-flex justify-content-between align-items-center"
                    >
                      <div class="day-title">
                        <i class="far fa-calendar-alt ml-2"></i>
                        <span>{{ work_day.day }}</span>
                      </div>
                      <v-switch
                        v-model="work_day.enabled"
                        hide-details
                        readonly
                        color="success"
                        class="mt-0 pt-0"
                      ></v-switch>
                    </div>

                    <div class="card-body p-0 mt-3">
                      <div
                        v-if="
                          work_day.enabled &&
                          work_day.times &&
                          work_day.times.length
                        "
                      >
                        <div
                          class="time-slot"
                          v-for="time in work_day.times"
                          :key="time.id"
                        >
                          <i class="far fa-clock ml-2"></i>
                          <span class="time-text">
                            <span class="time-badge">{{
                              time.start_time
                            }}</span>
                            <span
                              class="mx-2 text-muted"
                              style="font-size: 0.9rem"
                              >إلى</span
                            >
                            <span class="time-badge">{{ time.end_time }}</span>
                          </span>
                        </div>
                      </div>
                      <div v-else class="closed-badge">
                        <i class="far fa-store-alt-slash ml-2"></i>
                        <span>مغلق</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </div>

    <!-- Base Image Preview Modal -->
    <v-dialog
      v-model="model_1.show_model"
      max-width="850"
      content-class="creative_lightbox_dialog_overlay"
    >
      <v-card
        class="lightbox_card_wrapper text-center p-4 p-md-5"
        v-if="model_1.model_img_src"
      >
        <!-- Close Button -->
        <button
          class="lightbox_close_btn"
          @click="model_1.show_model = false"
          title="إغلاق المعاينة"
        >
          <i class="fal fa-times"></i>
        </button>

        <!-- Header -->
        <div class="lightbox_header mb-4">
          <div class="header_badge">
            <i class="fal fa-eye"></i>
            <span>معاينة مكبرة</span>
          </div>
          <h4 class="lightbox_title mt-2 mb-0" v-if="model_1.model_title">
            {{ model_1.model_title }}
          </h4>
        </div>

        <!-- Image Display Stage -->
        <div class="lightbox_stage mb-4">
          <div class="stage_glow_bg"></div>
          <img
            :src="model_1.model_img_src"
            alt="Preview"
            class="lightbox_image"
          />
        </div>

        <!-- Action Buttons Footer -->
        <div
          class="lightbox_footer_actions d-flex align-items-center justify-content-center gap-3"
        >
          <a
            :href="model_1.model_img_src"
            target="_blank"
            class="btn_lightbox_primary"
          >
            <i class="fal fa-external-link-alt"></i>
            <span>فتح بالحجم الكامل</span>
          </a>

          <a
            :href="model_1.model_img_src"
            download
            class="btn_lightbox_secondary"
          >
            <i class="fal fa-download"></i>
            <span>تحميل الصورة</span>
          </a>

          <button
            type="button"
            class="btn_lightbox_close"
            @click="model_1.show_model = false"
          >
            <span>إغلاق</span>
          </button>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import imageFalse from "@/assets/images/icons/logo.png";
import StoreBranches from "./showComponents/storeBranches.vue";
import Meals from "./showComponents/Meals.vue";
import AddBranch from "./showComponents/addNewBranch.vue";
import EditBranch from "./showComponents/editBranch.vue";
import BranchInfo from "./showComponents/BranchInfo.vue";
import StoreInfo from "./showComponents/storeInfo.vue";
import ShowBranch from "./showComponents/ShowBranch.vue";

export default {
  props: ["id"],
  name: "Withdraw",

  components: {
    StoreInfo,
    StoreBranches,
    Meals,
    AddBranch,
    EditBranch,
    BranchInfo,
    ShowBranch,
  },

  data() {
    return {
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.stores.title"),
          href: "/store/show-all",
        },
      ],

      statisticsItem: {},
      allData: null,
      allMealsData: null,

      active: this.$route.query.page || "info",

      loading: false,
      clear_fileds: false,
      model_1: {
        show_model: false,
        model_img_src: "",
        model_title: "",
      },
      statusModel: false,
      deactive_reason: null,
      statusLoading: false,
      acceptLoading: false,
      acceptModel: false,
      dialogDelete: false,
      isChangeBalanceModel: false,
      balanceLoading: false,
      branchId: null,
      myData: null,
      transaction: {
        type: null,
        amount: null,
      },
      types: [
        {
          id: "withdraw",
          name: "سحب",
        },
        {
          id: "charge",
          name: "ايداع",
        },
      ],
      itemToEdit: null,
    };
  },

  watch: {
    active(value) {
      if (value == "addBranch") {
        this.clear_fileds = !this.clear_fileds;
      } else if (value == "baranch_info") {
        this.$router.push({ query: { page: value, id: this.branchId } });
      } else if (value == "editBranch") {
        this.$router.push({ query: { page: value, id: this.branchId } });
      } else {
        this.$router.push({ query: { page: value } });
      }
    },
    ["$route.query.page"](value) {
      this.active = value;
    },
    statusModel() {
      this.deactive_reason = null;
    },
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
  },

  methods: {
    eidtBranch(item) {
      localStorage.setItem("zoz_store_branch", JSON.stringify(item));
      this.active = "editBranch";
      this.branchId = item.id;
    },
    showBranch(branch_id, place_id) {
      this.branchId = branch_id;
      this.placeId = place_id;
      this.active = "showBranch";
    },
    toggleBalance() {
      this.balanceLoading = true;
      if (!this.transaction.type) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل نوع التحويل",
          position: "bottomCenter",
        });
        this.balanceLoading = false;
        return;
      }
      if (!this.transaction.amount) {
        this.balanceLoading = false;
        return;
      }
      const formDta = new FormData();
      formDta.append("amount", this.transaction.amount);

      this.$axios
        .post(`${this.transaction.type.id}/${this.allData.id}`, formDta)
        .then((res) => {
          this.balanceLoading = false;
          this.isChangeBalanceModel = false;
          this.transaction.amount = null;
          this.transaction.type = null;
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomCenter",
          });
          this.setRows();
        })
        .catch((err) => {
          this.balanceLoading = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomCenter",
          });
        });
    },
    openImageModal(src, title) {
      if (!src) return;
      this.model_1.model_img_src = src;
      this.model_1.model_title = title || "معاينة الصورة";
      this.model_1.show_model = true;
    },
    show_model_1(e) {
      this.model_1.model_img_src = e.target?.src || e;
      this.model_1.model_title = "معاينة الصورة";
      this.model_1.show_model = true;
    },
    toggleBan() {
      this.banLoading = true;
      this.$axios.get(`drivers/${this.allData.id}/ban`).then(() => {
        this.banLoading = false;
        this.setRows();
      });
    },
    toggleacceptModel() {
      this.acceptModel = true;
    },
    changeAcceptStatus() {
      this.acceptLoading = true;
      const formData = new FormData();

      formData.append(
        "is_admin_active_user",
        this.allData.is_admin_active_user ? 0 : 1
      );
      formData.append("_method", "PUT");

      this.$axios({
        method: "POST",
        url: `/store/adminStatus/${this.allData.id}`,
        data: formData,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 5000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.acceptModel = false;
          this.acceptLoading = false;
          this.setRows();
        })
        .catch(() => {
          this.loading = false;
          this.loaderPage = false;
          this.acceptLoading = false;
        });
    },
    toggleStatusModel() {
      this.statusModel = true;
    },
    changeStatus() {
      if (!this.allData.is_ban && !this.deactive_reason) {
        this.$iziToast.error({
          message: "يرجي ادخال سبب الحظر اولا",
          timeout: 5000,
          position: "bottomRight",
        });
        return;
      }
      this.statusLoading = true;
      const formData = new FormData();
      formData.append("is_active", this.allData.is_ban ? 0 : 1);
      if (this.deactive_reason) {
        formData.append("message", this.deactive_reason);
      }
      formData.append("_method", "PUT");

      this.$axios({
        method: "POST",
        url: `/store/is_active/${this.allData.id}`,
        data: formData,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 5000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.statusModel = false;
          this.setRows();
          this.statusLoading = false;
        })
        .catch(() => {
          this.loading = false;
          this.loaderPage = false;
          this.statusLoading = false;
        });
    },
    toggleActive(active) {
      this.activeLoading = true;
      const FORM_DATA = new FormData();
      FORM_DATA.append("is_active", active);
      if (!active) {
        if (!this.deactivationReason) {
          this.$iziToast.error({
            timeout: 2000,
            message: "ادخل سبب الغاء التفعيل",
            position: "bottomCenter",
          });
          this.activeLoading = false;
          return;
        }
        FORM_DATA.append("deactivate_reason", this.deactivationReason);
      }
      this.$axios
        .post(`restaurants/${this.allData.id}/active`, FORM_DATA)
        .then(() => {
          this.activeLoading = false;
          this.isDeactivationModel = false;
          this.setRows();
        });
    },
    replaceImage(e) {
      e.target.src = imageFalse;
    },
    toggleDeleteModal(item) {
      this.deleteItemToShow = item;
      this.deleteModalIsOpen = !this.deleteModalIsOpen;
    },
    resetStore() {
      this.active = "branches";
      this.setRows();
    },
    infoBranch(item) {
      this.active = "baranch_info";
      this.branchRows(item.id);
      this.branchId = item.id;
    },
    setRows() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: "show_place/" + this.id,
      })
        .then((res) => {
          this.allData = res.data?.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    branchRows(id) {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: "show_place/" + id,
      })
        .then((res) => {
          this.myData = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },

  created() {
    this.setRows();
  },
};
</script>

<style lang="scss" scoped>
.main-store-details {
  padding: 10px 0;

  /* Top Hero Bar */
  .store-hero-card {
    background: #ffffff;
    border-radius: 20px;
    padding: 20px 24px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
    border: 1px solid rgba(0, 0, 0, 0.03);
    overflow: visible !important;

    .store-id-badge {
      font-size: 16px;
      color: #475569;
      display: inline-flex;
      align-items: center;

      .store-num {
        font-size: 19px;
        color: var(--mainColor-2, #783d73);
        margin-right: 4px;
      }
    }

    .custom-hero-btn {
      font-weight: 700;
      font-size: 13px;
      height: 42px !important;
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08) !important;
      transition: transform 0.2s ease, box-shadow 0.2s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12) !important;
      }
    }
  }

  /* Modern Card Container */
  .modern-card {
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
    border: 1px solid rgba(0, 0, 0, 0.03);
    overflow: hidden;

    .card-header-sm {
      padding: 16px 20px;
      background: linear-gradient(
        135deg,
        rgba(120, 61, 115, 0.04) 0%,
        rgba(120, 61, 115, 0.01) 100%
      );
      border-bottom: 1px solid rgba(0, 0, 0, 0.04);

      .title {
        font-size: 15px;
        font-weight: 700;
        color: #1e293b;
      }
    }
  }

  /* Store Sidebar */
  .store-sidebar-card {
    .store_image_container {
      .avatar-glow-ring {
        width: 110px;
        height: 110px;
        margin: 0 auto;
        border-radius: 24px;
        overflow: hidden;
        box-shadow: 0 8px 24px rgba(120, 61, 115, 0.18);
        border: 3px solid #ffffff;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .store_taps_container {
      list-style: none;
      padding: 0;
      margin: 0;

      .store_tap {
        margin-bottom: 8px;

        button {
          width: 100%;
          display: flex;
          align-items: center;
          padding: 12px 16px;
          border-radius: 14px;
          border: 1px solid rgba(0, 0, 0, 0.04);
          background: #f8fafc;
          color: #64748b;
          font-weight: 700;
          font-size: 14px;
          transition: all 0.25s ease;
          cursor: pointer;

          &:hover {
            background: rgba(120, 61, 115, 0.05);
            color: #783d73;
          }

          &.active {
            background: linear-gradient(
              135deg,
              var(--mainColor-2, #783d73),
              #9b4f95
            );
            color: #ffffff;
            box-shadow: 0 4px 14px rgba(120, 61, 115, 0.25);
            border-color: transparent;
          }
        }
      }
    }
  }

  /* Gallery Image Cards */
  .gallery-image-box {
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    height: 200px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(0, 0, 0, 0.04);
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }

    .image-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(120, 61, 115, 0.4);
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &:hover {
      img {
        transform: scale(1.05);
      }
      .image-overlay {
        opacity: 1;
      }
    }
  }

  /* Magic Time Cards */
  .worktimes-container {
    background: transparent;
  }
  .magic-time-card {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.03);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.03);
    border-radius: 18px;
    padding: 20px;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    position: relative;
    overflow: hidden;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 28px rgba(0, 0, 0, 0.06);
    }

    &.is-disabled {
      opacity: 0.75;
      background: #f8fafc;
      &:hover {
        transform: none;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
      }
    }

    .card-header {
      border-bottom: 2px dashed rgba(0, 0, 0, 0.06);
      padding-bottom: 12px;

      .day-title {
        font-size: 1.1rem;
        font-weight: 700;
        color: var(--mainColor-2, #783d73);
        display: flex;
        align-items: center;
      }
    }

    .time-slot {
      display: flex;
      align-items: center;
      background: #f8fafc;
      border-radius: 12px;
      padding: 10px 14px;
      margin-bottom: 8px;
      transition: all 0.2s ease;

      &:hover {
        background: #ffffff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      }

      i {
        font-size: 1.1rem;
        color: var(--mainColor-2, #783d73);
      }

      .time-text {
        font-weight: 600;
        color: #1e293b;
        display: flex;
        align-items: center;

        .time-badge {
          background: #ffffff;
          padding: 3px 8px;
          border-radius: 8px;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03);
          color: var(--mainColor-2, #783d73);
          font-family: "Inter", "Roboto", sans-serif;
        }
      }
    }

    .closed-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 10px;
      background: rgba(239, 68, 68, 0.08);
      color: #ef4444;
      border-radius: 12px;
      font-weight: 700;
      border: 1px dashed rgba(239, 68, 68, 0.3);
    }
  }

  .gap-2 {
    gap: 8px;
  }
  .gap-3 {
    gap: 14px;
  }

  /* STORE GALLERY STYLING */
  .store_gallery_wrapper {
    background: #ffffff;
    border-radius: 24px;
    border: 1px solid rgba(226, 232, 240, 0.9);
    box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.04);

    .gallery_header {
      border-bottom: 1px solid #f1f5f9;
      padding-bottom: 16px;

      .header_icon_box {
        width: 48px;
        height: 48px;
        border-radius: 16px;
        background: rgba(120, 61, 115, 0.1);
        color: var(--mainColor-2, #783d73);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.4rem;
      }

      .text_small {
        font-size: 0.825rem;
      }
    }

    .creative_gallery_card {
      background: #ffffff;
      border-radius: 20px;
      border: 1px solid rgba(226, 232, 240, 0.9);
      overflow: hidden;
      box-shadow: 0 8px 20px -5px rgba(15, 23, 42, 0.04);
      transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 15px 30px -5px rgba(15, 23, 42, 0.08);
        border-color: rgba(120, 61, 115, 0.3);
      }

      .card_tag_header {
        padding: 14px 18px;
        background: #f8fafc;
        border-bottom: 1px solid #f1f5f9;
        font-weight: 700;
        font-size: 0.9rem;
        color: #334155;
        display: flex;
        align-items: center;
        gap: 10px;

        i {
          color: var(--mainColor-2, #783d73);
          font-size: 1.05rem;
        }
      }

      .gallery_img_container {
        position: relative !important;
        height: 220px !important;
        width: 100% !important;
        background: #f1f5f9;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        overflow: hidden !important;

        .gallery_img {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important;
          display: block !important;
          transition: transform 0.4s ease;
        }

        .zoom_hover_overlay {
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          width: 100% !important;
          height: 100% !important;
          z-index: 5 !important;
          background: rgba(15, 23, 42, 0.72) !important;
          backdrop-filter: blur(4px) !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          color: #ffffff !important;
          opacity: 0;
          transition: opacity 0.3s ease;
          font-size: 0.875rem;
          font-weight: 700;

          .zoom_icon_box {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.2);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.3rem;
          }
        }

        &:hover {
          .gallery_img {
            transform: scale(1.08);
          }

          .zoom_hover_overlay {
            opacity: 1 !important;
          }
        }

        .empty_image_placeholder {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          color: #94a3b8;
          font-size: 0.85rem;
          font-weight: 500;

          i {
            font-size: 2.2rem;
          }
        }
      }
    }
  }
}

/* CREATIVE LIGHTBOX MODAL STYLING */
::v-deep .creative_lightbox_dialog_overlay {
  border-radius: 28px !important;
  overflow: hidden !important;
  box-shadow: 0 30px 70px -15px rgba(15, 23, 42, 0.45) !important;
}

.lightbox_card_wrapper {
  border-radius: 28px !important;
  background: #ffffff !important;
  position: relative;
  overflow: hidden;

  .lightbox_close_btn {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #f1f5f9;
    color: #64748b;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    z-index: 10;

    &:hover {
      background: #0f172a;
      color: #ffffff;
      transform: rotate(90deg) scale(1.08);
    }
  }

  .lightbox_header {
    .header_badge {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 5px 16px;
      border-radius: 50px;
      background: rgba(120, 61, 115, 0.08);
      color: var(--mainColor-2, #783d73);
      font-size: 0.825rem;
      font-weight: 700;
    }

    .lightbox_title {
      font-weight: 800;
      color: #0f172a;
      font-size: 1.35rem;
    }
  }

  .lightbox_stage {
    position: relative;
    max-height: 520px;
    border-radius: 20px;
    background: #0f172a;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    overflow: hidden;
    box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.4);

    .stage_glow_bg {
      position: absolute;
      inset: 0;
      background: radial-gradient(
        circle at center,
        rgba(120, 61, 115, 0.25) 0%,
        transparent 70%
      );
      pointer-events: none;
    }

    .lightbox_image {
      max-width: 100%;
      max-height: 480px;
      object-fit: contain;
      border-radius: 12px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.02);
      }
    }
  }

  .lightbox_footer_actions {
    .btn_lightbox_primary {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 10px 24px;
      border-radius: 50px;
      background: linear-gradient(
        135deg,
        var(--mainColor-2, #783d73) 0%,
        #9b4f95 100%
      );
      color: #ffffff !important;
      font-weight: 700;
      font-size: 0.9rem;
      text-decoration: none;
      box-shadow: 0 10px 20px -5px rgba(120, 61, 115, 0.35);
      transition: all 0.25s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 14px 25px -5px rgba(120, 61, 115, 0.45);
      }
    }

    .btn_lightbox_secondary {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 10px 24px;
      border-radius: 50px;
      background: #f1f5f9;
      color: #334155 !important;
      font-weight: 700;
      font-size: 0.9rem;
      text-decoration: none;
      border: 1px solid #e2e8f0;
      transition: all 0.25s ease;

      &:hover {
        background: #e2e8f0;
        color: #0f172a !important;
        transform: translateY(-2px);
      }
    }

    .btn_lightbox_close {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 10px 24px;
      border-radius: 50px;
      background: transparent;
      color: #64748b;
      font-weight: 700;
      font-size: 0.9rem;
      border: 2px solid #cbd5e1;
      cursor: pointer;
      transition: all 0.25s ease;

      &:hover {
        background: #f8fafc;
        border-color: #94a3b8;
        color: #334155;
      }
    }
  }
}
</style>
